import React from "react";
import { CcButton } from "../mui";
import CcModal from "./CcModal";

/**
 * CcConfirmModal — Zen editorial confirmation dialog (replaces the glass
 * ConfirmModal on migrated flows). Cancel + a single confirm action;
 * `tone="danger"` for destructive confirmations (archive, delete);
 * `tone="warn"` for attention-before-you-proceed confirmations (the AI
 * review acknowledgement) — the description renders as an amber callout so
 * the dialog reads as a warning, while confirm stays a primary action.
 *
 * `children` are optional and render below the description — for the small
 * amount of input a confirmation is allowed to ask for (a "why" note on a
 * decision that has to be recorded). Anything larger belongs in CcModal.
 */
const CcConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  children,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  tone = "primary",
  disabled = false,
}) => (
  <CcModal
    open={open}
    onClose={onClose}
    title={title}
    maxWidth="xs"
    footer={
      <>
        <CcButton variant="secondary" onClick={onClose} disabled={disabled}>
          {cancelLabel}
        </CcButton>
        <CcButton
          variant={tone === "danger" ? "danger" : "primary"}
          onClick={onConfirm}
          disabled={disabled}
        >
          {confirmLabel}
        </CcButton>
      </>
    }
  >
    {description ? (
      <p
        className={
          tone === "warn"
            ? "cc-modal__subtitle cc-confirm-modal__warn"
            : "cc-modal__subtitle"
        }
      >
        {description}
      </p>
    ) : null}
    {children}
  </CcModal>
);

export default CcConfirmModal;
